module.exports = __webpack_public_path__ + "static/media/macbook@3x.ec3a7b37.png";